import _ from 'lodash'

import app from '../app.jsx'

function _createEmptyBudget () {
  return { phases: [] }
}

function _getRenderObject (budgetObj, items) {
  const budget = _.cloneDeep(budgetObj)
  budget.lastActivityId = 1

  budget.phases.map((phase, phaseId) => {
    phase.id = phaseId
    phase.editable = false
    phase.bTitleCompleted = true
    phase.showAdd = false

    const groups = []
    items.map((item, _itemIdx) => {
      if (item.phaseNo === phaseId + 1) {
        const itemObj = _.cloneDeep(item)
        const groupIdx = item.groupNo - 1

        if (groups[groupIdx] === undefined) {
          groups[groupIdx] = {
            id: groupIdx,
            items: []
          }
        }

        delete item.phaseNo
        delete item.groupNo
        delete item.orderNo

        itemObj.dragId = budget.lastActivityId++
        itemObj.phaseId = phaseId
        itemObj.groupId = groupIdx
        itemObj.editable = false
        itemObj.bTitleCompleted = true
        itemObj.showAdd = false

        groups[groupIdx].items.push(itemObj)
      }
    })

    // If the last groups last item is subtotal - then add empty new group
    if (groups.length > 0) {
      const lastGroupIdx = groups.length - 1
      const lastGroup = groups[lastGroupIdx]

      if (lastGroup.items.length > 0) {
        const lastItemIdx = lastGroup.items.length - 1
        const lastItem = lastGroup.items[lastItemIdx]

        if (lastItem.type === 'subtotal') {
          const newGroup = { id: groups.length, items: [] }
          groups.push(newGroup)
        }
      }
    } else {
      // Empty group for dropping items
      const newGroup = { id: groups.length, items: [] }
      groups.push(newGroup)
    }

    phase.groups = groups
  })
  return budget
}

function _getSaveObject (budgetObj) {
  const items = []
  const budget = _.cloneDeep(budgetObj)

  delete budget.lastActivityId

  budget.phases.map((phase, phaseIdx) => {
    const groups = phase.groups

    delete phase.id
    delete phase.editable
    delete phase.bTitleCompleted
    delete phase.bEdit
    delete phase.groups
    delete phase.spentAmount
    delete phase.showAdd

    groups.map((group, groupIdx) => {
      _.remove(group.items, obj => obj.isEmptyDragItem)

      group.items.map((item, itemIdx) => {
        const itemObj = _createSaveItemObject(_.cloneDeep(item))

        itemObj.phaseNo = phaseIdx + 1
        itemObj.groupNo = groupIdx + 1
        itemObj.orderNo = itemIdx + 1

        items.push(itemObj)
      })
    })
  })

  return { budget, items }
}

function _getNewItemObject (item) {
  const phaseId = item.phaseId
  const groupId = item.groupId
  const itemObj = _createSaveItemObject(_.cloneDeep(item))

  itemObj.phaseNo = phaseId + 1
  itemObj.groupNo = groupId + 1

  return itemObj
}

function _createSaveItemObject (itemObj) {
  delete itemObj.dragId
  delete itemObj.phaseId
  delete itemObj.groupId
  delete itemObj.orgPhaseId
  delete itemObj.orgGroupId
  delete itemObj.orgIndex
  delete itemObj.editable
  delete itemObj.bTitleCompleted
  delete itemObj.bEdit
  delete itemObj.spentAmount
  delete itemObj.bUpdateTotal
  delete itemObj.bSaveItem
  delete itemObj.showAdd

  return itemObj
}

function _getUpdateItemObject (itemObj, attribute) {
  attribute = Array.isArray(attribute) ? attribute : [attribute]
  const updateObj = {}
  attribute.map(attr => {
    updateObj[attr] = itemObj[attr]
  })

  return updateObj
}

function _createNewActivity (budget, type, phaseId, groupId, vat) {
  return {
    id: null,
    dragId: budget.lastActivityId++,
    type: type,
    title: '',
    summary: '',
    description: '',
    total: 0,
    noHours: '',
    pricePerHour: '',
    editable: 'title',
    bTitleCompleted: false,
    phaseId: phaseId,
    groupId: groupId,
    vat: vat,
    labelType: '',
    showAdd: false
  }
}

function _createInvoice (createObj, params, callback) {
  createObj.createdById = app.loggedInId
  createObj.status = 'Draft'
  app.service('api/invoice').timeout = 10000
  app
    .service('/api/invoice')
    .create(createObj, params || {})
    .then(createRes => {
      if (createRes) {
        callback(null, createRes)
      }
    })
    .catch(createErr => {
      callback(createErr, null)
    })
}

function _generateInvoice (params, callback) {
  app.service('/api/invoice/generate').timeout = 10000
  app
    .service('/api/invoice/generate')
    .find(params)
    .then(result => {
      if (result) {
        callback(result)
      } else {
        callback(null)
      }
    })
    .catch(_err => {
      callback(null)
    })
}

function _getNewItemExpenseObject (item) {
  const itemObj = _createSaveItemExpenseObject(_.cloneDeep(item))
  return itemObj
}

function _createSaveItemExpenseObject (itemObj) {
  delete itemObj.editable
  delete itemObj.bTitleCompleted
  delete itemObj.bEdit

  if (itemObj.type === 'expense') {
    itemObj.expenseTotal = itemObj.sellingPrice
  } else {
    itemObj.timeTotal = itemObj.pricePerHour * (itemObj.noHours / 60)
  }

  return itemObj
}

function _getUpdateItemExpenseObject (itemObj, attribute) {
  const updateObj = {}
  updateObj[attribute] = itemObj[attribute]

  if (attribute === 'pricePerHour' || attribute === 'noHours') {
    updateObj.timeTotal = itemObj.pricePerHour * (itemObj.noHours / 60)
    itemObj.timeTotal = updateObj.timeTotal
  } else if (attribute === 'purchasePrice') {
    updateObj.sellingPrice = itemObj.purchasePrice
    updateObj.expenseTotal = itemObj.purchasePrice
    itemObj.sellingPrice = updateObj.purchasePrice
    itemObj.expenseTotal = updateObj.purchasePrice
  } else if (attribute === 'sellingPrice') {
    updateObj.expenseTotal = itemObj.sellingPrice
    itemObj.expenseTotal = updateObj.expenseTotal
  }

  return updateObj
}

function _calculateRecurringInfo (interval, startDate, noInvoices) {
  let lastRecurringDate = null
  let noTotal = 0

  let tempRecurringDate = new Date(startDate)
  while (noTotal < noInvoices) {
    lastRecurringDate = new Date(tempRecurringDate)

    noTotal++
    tempRecurringDate = _getNextRecurringDate(tempRecurringDate, interval)
  }

  return lastRecurringDate
}

function _getNextRecurringDate (date, interval) {
  return _calculateRecurringDate(date, interval, 1)
}

/* Private functions */
function _calculateRecurringDate (date, interval, step) {
  let nextRecurringDate = new Date(date)

  if (interval === 'weekly') {
    nextRecurringDate.setDate(nextRecurringDate.getDate() + 7 * step)
  } else if (interval === 'monthly') {
    nextRecurringDate = _addMonths(nextRecurringDate, 1, step)
  } else if (interval === 'quaterly') {
    nextRecurringDate = _addMonths(nextRecurringDate, 3, step)
  } else if (interval === 'yearly') {
    nextRecurringDate.setYear(nextRecurringDate.getFullYear() + 1 * step)
  }

  return nextRecurringDate
}

function _addMonths (nextRecurringDate, month, step) {
  let tempDate = new Date(nextRecurringDate)
  tempDate.setMonth(tempDate.getMonth() + month * step)
  if (nextRecurringDate.getDate() !== tempDate.getDate()) {
    tempDate = new Date(nextRecurringDate)
    tempDate.setMonth(tempDate.getMonth() + (month * step + 1), 0)
  }

  return tempDate
}

function _getProjects (contactId, callback) {
  if (contactId) {
    const params = {
      query: {
        contactId: contactId,
        status: { $nin: ['closed'] }
      }
    }

    app
      .service('/api/project')
      .find(params)
      .then(result => {
        if (result) {
          const options = result.data.map(obj => ({
            label: [
              app.projectSetting &&
                app.projectSetting.useProjectNo &&
                obj.projectNumber,
              obj.title
            ]
              .filter(Boolean)
              .join(' | '),
            value: obj.id
          }))
          callback(options)
        } else {
          callback([]) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(err => {
        app.debug('InvoiceUtil: _getProjects - Error: ', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  } else {
    callback([]) // eslint-disable-line standard/no-callback-literal
  }
}

const InvoiceUtil = {}
InvoiceUtil.createEmptyBudget = _createEmptyBudget
InvoiceUtil.getSaveObject = _getSaveObject
InvoiceUtil.getRenderObject = _getRenderObject
InvoiceUtil.getNewItemObject = _getNewItemObject
InvoiceUtil.getUpdateItemObject = _getUpdateItemObject
InvoiceUtil.createNewActivity = _createNewActivity
InvoiceUtil.createInvoice = _createInvoice
InvoiceUtil.generateInvoice = _generateInvoice
InvoiceUtil.getNewItemExpenseObject = _getNewItemExpenseObject
InvoiceUtil.getUpdateItemExpenseObject = _getUpdateItemExpenseObject
InvoiceUtil.calculateRecurringInfo = _calculateRecurringInfo
InvoiceUtil.getNextRecurringDate = _getNextRecurringDate
InvoiceUtil.getProjects = _getProjects

export default InvoiceUtil
